export default __webpack_public_path__ + "images/whellchair.68cfb04.svg";